/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileHtmlShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586z" />
        <path d="M8 14.977h1.527V17h1.045v-4.87H9.527v1.962H8zM7.53 14H6.485v-1.87H7.53zM18 20v-1h2v3H8v-2zm-5.787-3v-3.986h-1.44v-.885h3.926v.885h-1.44V17zm2.689 0v-4.87h1.092l1.548 3.208 1.527-3.209h1.092V17H19.13v-3.156l-1.287 2.687H17.2l-1.286-2.646V17zm5.713 0v-4.87h1.046v3.939h2.144V17zm-18.141.474L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileHtmlShortcut as FileHtmlShortcut };
